import { SubAreaContent } from "../../../contentManager/SubAreaContent";

export const Talents = () => {
    return <div>
        <h2>Kompetenzen & Talente</h2>
        <SubAreaContent area={"competenceTalents"} isProjectSpecific={true} notes={true} />;
    </div>;
};